import { z } from "@/hooks/schema";
import { Form } from "@/components/Form";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  GenderLabel,
  MaritalStatusLabel,
  EthnicityLabel,
  EducationLevelLabel,
} from "@/types/employeeFicha";

export const personalDataSchema = z.object({
  father_name: z.string().optional(),
  mother_name: z.string().optional(),
  birth_date: z.string().optional(),
  birthplace: z.string().optional(),
  birthplace_state: z.string().optional(),
  nationality: z.string().optional(),
  gender: z.string().optional(),
  marital_status: z.string().optional(),
  ethnicity: z.string().optional(),
  education_level: z.string().optional(),
  mobile_phone: z.string().optional(),
});

// Selects/datas não devem ir como string vazia (mesmo problema do HrFieldsStep).
export const PERSONAL_DATA_OMIT_WHEN_EMPTY = [
  "birth_date",
  "gender",
  "marital_status",
  "ethnicity",
  "education_level",
];

const EnumSelect = ({
  label,
  options,
  field,
}: {
  label: string;
  options: Record<number, string>;
  field: { value: string; onChange: (value: string) => void };
}) => (
  <Form.Item>
    <Form.Label>{label}</Form.Label>
    <Select onValueChange={field.onChange} value={field.value}>
      <SelectTrigger>
        <SelectValue placeholder="Selecione" />
      </SelectTrigger>
      <SelectContent>
        {Object.entries(options).map(([value, optionLabel]) => (
          <SelectItem key={value} value={value}>
            {optionLabel}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </Form.Item>
);

export const PersonalDataStep = () => {
  return (
    <>
      <Form.Row>
        <Form.Field name="father_name">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Nome do Pai</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Nome do pai" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
        <Form.Field name="mother_name">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Nome da Mãe</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Nome da mãe" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>

      <Form.Row>
        <Form.Field name="birth_date">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Nascimento</Form.Label>
              <Form.Control>
                <Input {...field} type="date" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
        <Form.Field name="nationality">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Nacionalidade</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Ex: Brasileira" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>

      <Form.Row>
        <Form.Field name="birthplace">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Naturalidade</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Cidade de nascimento" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
        <Form.Field name="birthplace_state">
          {({ field }) => (
            <Form.Item>
              <Form.Label>UF</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Ex: CE" maxLength={2} />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>

      <Form.Row>
        <Form.Field name="gender">
          {({ field }) => (
            <EnumSelect
              label="Sexo"
              options={GenderLabel}
              field={field}
            />
          )}
        </Form.Field>
        <Form.Field name="marital_status">
          {({ field }) => (
            <EnumSelect
              label="Estado Civil"
              options={MaritalStatusLabel}
              field={field}
            />
          )}
        </Form.Field>
      </Form.Row>

      <Form.Row>
        <Form.Field name="ethnicity">
          {({ field }) => (
            <EnumSelect
              label="Etnia ou Raça"
              options={EthnicityLabel}
              field={field}
            />
          )}
        </Form.Field>
        <Form.Field name="education_level">
          {({ field }) => (
            <EnumSelect
              label="Instrução"
              options={EducationLevelLabel}
              field={field}
            />
          )}
        </Form.Field>
      </Form.Row>

      <Form.Row>
        <Form.Field name="mobile_phone">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Celular</Form.Label>
              <Form.Control>
                <Input {...field} typeMask="phone" placeholder="Celular" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>
    </>
  );
};
